
import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';

const ProfileLoading = () => {
  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-6xl mx-auto px-4 py-8">
        {/* Header Skeleton */}
        <div className="mb-8">
          <Skeleton className="h-10 w-24 rounded-md" />
        </div>
        
        {/* Profile Header Skeleton */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Left Column - Image */}
          <div className="md:col-span-1">
            <Skeleton className="w-full aspect-square rounded-xl mb-6" />
            <div className="space-y-4">
              <Skeleton className="h-6 w-32" />
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-10 w-full rounded-md" />
            </div>
          </div>
          
          {/* Right Column - Basic Info */}
          <div className="md:col-span-2">
            <Skeleton className="h-8 w-40 mb-2" />
            <Skeleton className="h-10 w-3/4 mb-4" />
            <div className="flex flex-wrap gap-2 mb-6">
              <Skeleton className="h-5 w-24 rounded-full" />
              <Skeleton className="h-5 w-32 rounded-full" />
              <Skeleton className="h-5 w-28 rounded-full" />
            </div>
            <Skeleton className="h-24 w-full mb-4" />
            <div className="space-y-4 mb-6">
              <Skeleton className="h-6 w-32" />
              <div className="flex flex-wrap gap-2">
                <Skeleton className="h-8 w-20 rounded-full" />
                <Skeleton className="h-8 w-24 rounded-full" />
                <Skeleton className="h-8 w-28 rounded-full" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileLoading;
